import admissions from './admissions/'
import fileDownload from './fileDownload/'

import libraryFileDownload from './libraryFileDownload/'
export default {
  admissions,
  fileDownload,
  libraryFileDownload
}
